import React from 'react';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section className="w-full bg-pine" data-id="element-385" data-mp="2bwe6imbbrd3g">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center sm:py-16" data-id="element-386" data-mp="2bvcvuiy80sm9">
        <p className="eyebrow text-sky" data-id="element-387" data-mp="1wzwzg7a64kmp">Limited-time offer</p>
        <h2 className="mt-3 font-display text-3xl uppercase text-paper sm:text-5xl" data-id="element-388" data-mp="1x1rhndu21yn3">
          The launch price ends in:
        </h2>
        <div className="mt-6" data-id="element-389" data-mp="1o6jug6ytxsk9">
          <Countdown tone="dark" data-id="element-390" data-mp="1o5ij01dwj420" />
        </div>
        <p className="mt-5 text-sm text-paper/75" data-id="element-391" data-mp="1sxtl9aw471xq">
          After that the price goes up by{' '}
          <span className="font-bold text-ember" data-id="element-392" data-mp="1e8xah62obatf">$42</span> and stays there.
        </p>
      </div>
    </section>;
}